/**
 * Trunnion AI - Approval Queue Panel Component
 * List of pending approval requests within the notification center.
 */

import { Check } from 'lucide-react';
import { useNotificationStore } from '@/stores/notificationStore';
import { ApprovalItem } from './ApprovalItem';

export function ApprovalQueuePanel() {
  const { approvalQueue } = useNotificationStore();

  if (approvalQueue.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 px-4">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-trunnion-slate-800">
          <Check className="h-6 w-6 text-trunnion-slate-500" />
        </div>
        <p className="mt-3 text-sm font-medium text-trunnion-slate-400">
          No pending approvals
        </p>
        <p className="mt-1 text-xs text-trunnion-slate-500">
          Workflow steps requiring your approval will appear here
        </p>
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto" role="list">
      {approvalQueue.map((item) => (
        <ApprovalItem key={item.id} item={item} />
      ))}
    </div>
  );
}
